import { createStyles } from '@mantine/core'

type StylesParams = {
  isFullScreen: boolean
  showBanner: boolean
}

export default createStyles(
  (theme, { isFullScreen, showBanner }: StylesParams) => {
    return {
      root: {},
      topArea: {
        position: 'relative',
      },
      dragHandler: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
      },
      drawerBody: {
        position: 'relative',
        padding: 0,
        ...(!showBanner && {
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          '.mantine-SuccessBox-root,.mantine-SuccessBox-body': {
            gap: 24,
          },
        }),
        '.mantine-SuccessBox-description': {
          textAlign: 'left',
        },
      },
      drawerContent: {
        transitionProperty: 'transform, opacity,height !important' as any,
        ...(!isFullScreen && {
          borderTopLeftRadius: 24,
          borderTopRightRadius: 24,
        }),
      },
      bannerImg: {
        ...(!isFullScreen && {
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
        }),
      },
      formArea: {
        padding: 16,
      },
      form: {},
      closeWithIconBtn: {
        position: 'absolute',
        top: '10px !important' as any,
        right: '10px !important' as any,
        zIndex: 1,
        width: 40,
        height: 40,
        borderRadius: '50%',
        backgroundColor: '#fff',
        '&:hover': {
          backgroundColor: theme.colors.neutral[0],
        },
      },
    }
  },
)
